import React from "react";
import Content from "../../commons/components/content"
import DataContainer from "./dataContainer"
import urlParameters from "../../commons/utils/urlParameters";

export default () => {

    const showFormEdit = () => {
        let url = window.location.href;
        let parameters = urlParameters(url);
        if (parameters["edit"] === "true") {
            return true;
        }
        return false;
    }

    return (
        <Content>
            <DataContainer edit_form={showFormEdit()}/>
        </Content>
    )
}
